import { graphql, useStaticQuery } from 'gatsby';
import { type ArticleNode } from '../components/ArticleDiscoveryArticles/ArticleDiscoveryArticles.types';

export const useAllArticles = (): ArticleNode[] => {
  const data = useStaticQuery<Queries.ArticleDiscoveryQueryQuery>(graphql`
    query ArticleDiscoveryQuery {
      allKontentItemArticlePage(
        filter: { preferred_language: { eq: "en" } }
        sort: { elements: { creation_date: { value: DESC } } }
      ) {
        nodes {
          value {
            index_subheadline {
              value
            }
            index_perex {
              value
            }
            index_image {
              value {
                description
                height
                url
                width
              }
            }
            index_icon {
              value {
                description
                url
              }
            }
            index_headline {
              value
            }
            index_cta {
              value
            }
            category {
              value {
                ... on kontent_item_article_category {
                  __typename
                  system {
                    id
                  }
                  elements {
                    name {
                      value
                    }
                    url_slug {
                      value
                    }
                  }
                }
              }
            }
            tags {
              value {
                elements {
                  facet {
                    value {
                      elements {
                        name {
                          value
                        }
                      }
                    }
                  }
                  name {
                    value
                  }
                }
              }
            }
            index_card_clickable {
              value
            }
          }
          system {
            id
            codename
          }
        }
      }
    }
  `);

  return data.allKontentItemArticlePage.nodes as ArticleNode[];
};
